import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'notificationsForm' ];

  submitForm(_event) {
    this.notificationsFormTarget.submit();
  }
}
